import React from 'react';

interface ActionButtonProps {
  onClick?: (e: React.MouseEvent) => void;
  variant?: 'default' | 'supreme';
  isAvailable?: boolean;
  isLive?: boolean;
}

export const VideoButton: React.FC<ActionButtonProps> = ({ 
  onClick, 
  isAvailable = true,
  isLive = false
}) => {
  const baseStyles = "flex flex-col items-center justify-center p-2 rounded-xl transition-all duration-300";
  
  // 🟢 FIXED: Removed the 'supreme' check. It stays perfectly purple!
  const activeColorStyles = "bg-purple-200 text-purple-600 hover:bg-purple-300 active:scale-95 group/btn";

  const disabledStyles = "bg-gray-100 text-gray-400 cursor-not-allowed border border-gray-200 opacity-80";

  const canClick = isAvailable && !isLive;
  const finalStyles = `${baseStyles} ${canClick ? activeColorStyles : disabledStyles}`;

  return (
    <button 
      onClick={canClick ? onClick : undefined} 
      disabled={!canClick} 
      className={finalStyles}
      title={isLive ? "Expert is currently in a Live Session" : ""}
    >
      <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 mb-1 ${canClick ? 'group-hover/btn:scale-110 transition-transform' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
      <span className="text-[10px] font-bold">Video</span>
    </button>
  );
};